// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ce204542","171":"84e6feb0","432":"f25a3dfc","994":"0cc12f8e"}[chunkId] + ".chunk.js";
};